import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "manifold m-campaign"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  id: "claim-button-image"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_campaign_popup = _resolveComponent("m-campaign-popup")!
  const _component_loading_screen = _resolveComponent("loading-screen")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.DATA_WIDGET_VALUE + ' manifold')
  }, [
    (_ctx.state.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            class: "m-campaign-button",
            disabled: _ctx.disabled,
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openPopup && _ctx.openPopup(...args)))
          }, [
            (_ctx.claimButtonImage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("img", { src: _ctx.claimButtonImage }, null, 8, _hoisted_4)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.buttonText), 1))
          ], 8, _hoisted_2),
          (_ctx.popupIsOpen)
            ? (_openBlock(), _createBlock(_component_m_campaign_popup, {
                key: 0,
                onClose: _ctx.close
              }, null, 8, ["onClose"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.state.loaded)
      ? (_openBlock(), _createBlock(_component_loading_screen, { key: 1 }))
      : _createCommentVNode("", true)
  ], 2))
}